import { render, staticRenderFns } from "./gdDevice.vue?vue&type=template&id=ffedc0f4"
import script from "./gdDevice.vue?vue&type=script&lang=js"
export * from "./gdDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports